import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import ShopSection from "@/components/ShopSection";
import Gallery from "@/components/Gallery";
import Heritage from "@/components/Heritage";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Services />
      <ShopSection />
      <Gallery />
      <Heritage />
      <Contact />
      <Footer />
    </main>
  );
}
